/* 20/10/2026 (audit SEO, Antonio: il momento di apertura del popup in Shopify Forms non si può cambiare).
   Su mobile il popup newsletter «10% di sconto» si apriva appena arrivati e copriva metà schermo: Google
   penalizza i popup che coprono il contenuto all'arrivo da una ricerca, non quelli dopo un'interazione.
   Qui: su mobile la pagina parte «in attesa» (il CSS in custom.css nasconde shopify-forms-embed) e la libera
   quando il visitatore ha scorso un quarto di schermo. La raccolta email resta, cambia solo il momento. */
(function () {
  try {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    var r = document.documentElement;
    r.classList.add('ms-forms-attesa');
    var libera = function () {
      if (window.scrollY > window.innerHeight * 0.25) {
        r.classList.remove('ms-forms-attesa');
        window.removeEventListener('scroll', libera);
      }
    };
    window.addEventListener('scroll', libera, { passive: true });
  } catch (e) { /* mai rompere la pagina per un popup */ }
})();
